import { create } from 'zustand';
import { type SupplierPerson } from '@entities/supplier';

interface SupplierPersonStore {
  supplierPersons: SupplierPerson[];
  setSupplierPersons: (supplierPersons: SupplierPerson[]) => void;
  addSupplierPerson: (supplierPerson: SupplierPerson) => void;
  deleteSupplierPerson: (id: string) => void;
  getPersonsBySupplier: (supplierId: string) => SupplierPerson[];
  getSuppliersByPerson: (personId: string) => SupplierPerson[];
  deleteSupplierPersonsBySupplier: (supplierId: string) => void;
  deleteSupplierPersonsByPerson: (personId: string) => void;
}

export const useSupplierPersonStore = create<SupplierPersonStore>((set, get) => ({
  supplierPersons: [],
  setSupplierPersons: (supplierPersons) => set({ supplierPersons }),
  addSupplierPerson: (supplierPerson) =>
    set((state) => ({ supplierPersons: [...state.supplierPersons, supplierPerson] })),
  deleteSupplierPerson: (id) =>
    set((state) => ({
      supplierPersons: state.supplierPersons.filter((sp) => sp.id !== id),
    })),
  getPersonsBySupplier: (supplierId) =>
    get().supplierPersons.filter((sp) => sp.supplier_id === supplierId),
  getSuppliersByPerson: (personId) =>
    get().supplierPersons.filter((sp) => sp.person_id === personId),
  deleteSupplierPersonsBySupplier: (supplierId) =>
    set((state) => ({
      supplierPersons: state.supplierPersons.filter((sp) => sp.supplier_id !== supplierId),
    })),
  deleteSupplierPersonsByPerson: (personId) =>
    set((state) => ({
      supplierPersons: state.supplierPersons.filter((sp) => sp.person_id !== personId),
    })),
}));
